module.exports = __webpack_public_path__ + "img/35.35ab1da3.png";